import { Box, FormControl, MenuItem, Select, Typography } from "@mui/material";

const FieldGroupComp = ({
  oldLabel,
  newLabel,
  oldComponent,
  newComponent,
  reasonValue,
  setReasonValue,
  reasonAttributes = [],
  dropDownVisible = false,
}) => {
  return (
    <Box
      sx={{
        pr: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "left",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
        <Typography variant="caption" sx={{ mr: 1 }}>
          {oldLabel}
        </Typography>
        {oldComponent}
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
        <Typography variant="caption" sx={{ mr: 1 }}>
          {newLabel}
        </Typography>
        {newComponent}
      </Box>

      {dropDownVisible && (
        // <Box>
        <FormControl size="small" sx={{ minWidth: 140, padding: "3px" }}>
          <Select
            displayEmpty
            value={reasonValue || ""}
            onChange={(e) => setReasonValue(e.target.value)}
            renderValue={(selected) =>
              selected
                ? reasonAttributes.find((x) => x.UID === selected)?.Name1
                : "Select Reason"
            }
            sx={{
              padding: "0 !important",
            }}
          >
            {reasonAttributes.map((opt) => (
              <MenuItem
                sx={{
                  height: "31px",
                  minHeight: "31px",
                  padding: "0 8px",
                  display: "flex",
                  alignItems: "center",
                }}
                key={opt.UID}
                value={opt.UID}
              >
                {opt.Name1}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        // </Box>
      )}
    </Box>
  );
};

export default FieldGroupComp;
